import { render, staticRenderFns } from "./HeaderAdminNotification.vue?vue&type=template&id=6644a608"
import script from "./HeaderAdminNotification.vue?vue&type=script&lang=js"
export * from "./HeaderAdminNotification.vue?vue&type=script&lang=js"
import style0 from "./HeaderAdminNotification.vue?vue&type=style&index=0&id=6644a608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports